// extracted by mini-css-extract-plugin
export default {"formFields__categoriesCheckbox":"styles_formFields__categoriesCheckbox__iNxGx"};